import { z } from "zod";
import { PaginationRequestSchema, PaginationResponseSchema } from "./pagination";

export const DisciplineEventTypeQuerySchema = PaginationRequestSchema.extend({
  disciplineId: z.string().optional(),
  name: z.string().optional(),
});
export type DisciplineEventTypeQueryDTO = z.infer<typeof DisciplineEventTypeQuerySchema>;

export const CreateDisciplineEventTypeRequestSchema = z.object({
  disciplineId: z.string().min(1, "La disciplina es requerida"),
  name: z.string().min(1, "El nombre es requerido"),
  description: z.string().optional(),
  color: z.string().optional(),
  order: z.number().int().optional().default(0),
});

export const UpdateDisciplineEventTypeRequestSchema =
  CreateDisciplineEventTypeRequestSchema.partial();

export type CreateDisciplineEventTypeRequestDTO = z.infer<
  typeof CreateDisciplineEventTypeRequestSchema
>;
export type UpdateDisciplineEventTypeRequestDTO = z.infer<
  typeof UpdateDisciplineEventTypeRequestSchema
>;

export const DisciplineEventTypeResponseSchema = z.object({
  id: z.string(),
  disciplineId: z.string(),
  disciplineName: z.string().nullable(),
  name: z.string(),
  description: z.string().nullable(),
  color: z.string().nullable(),
  status: z.string(),
  order: z.number(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type DisciplineEventTypeResponseDTO = z.infer<
  typeof DisciplineEventTypeResponseSchema
>;

export const DisciplineEventTypesPaginatedResponseSchema = PaginationResponseSchema(
  DisciplineEventTypeResponseSchema,
);
export type DisciplineEventTypesPaginatedResponseDTO = z.infer<
  typeof DisciplineEventTypesPaginatedResponseSchema
>;
